import Listing from './listing'
import SearchBar from './SearchBar'
import AddUpdateLogos from './addUpdateLogos';
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { getPrivileges } from '../../common/adminPrivilege';
import DeleteModal from "../../common/deleteModal";
import { getDataSchoolLogos, deleteSchoolLogo } from '../../services/manage-school-logos/action';
import { getAdminPaginationLimit } from '../../../common/common';

const SchoolLogoIndex = () => {
    const [logoId, setLogoId] = useState(false);
    const [formshow, setFormShow] = useState(false);
    const [deleteid, setDeleteId] = useState(null);
    const [deleteshow, setDeleteShow] = useState(false);
    const getPrivilege = getPrivileges();
    const editSchoolLogs = getPrivilege.canEditSchoolLogs();
    const [currentPage, setCurrentPage] = useState(1);
    const limit = getAdminPaginationLimit();
    const requestBody = {
        page: currentPage,
        limit: limit,
        keyword: ""
    };
    const [filterdata, setFilterData] = useState(requestBody);
    const dispatch = useDispatch()
    const { logos, totalCount } = useSelector((state) => state.logos)
    const loading = useSelector((state) => state.logos.loading)
    const error = useSelector((state) => state.logos.error)

    useEffect(() => {
        dispatch(getDataSchoolLogos(requestBody))
    }, []);

    const handleFormShow = async (id) => {
        try {
            if (typeof id === "number") {
                setLogoId(id);
            }
        } catch (error) { }
        setFormShow(true);
    }
    const handleFormClose = () => {
        setLogoId(false);
        setFormShow(false);
    }
    const handlePaginate = (selectedPage) => {
        const updatedFilterData = {
            ...filterdata,
            page: selectedPage.selected + 1,
        };
        setCurrentPage(selectedPage.selected + 1);
        setFilterData(updatedFilterData);
        dispatch(getDataSchoolLogos(updatedFilterData))
    };
    const calculateSerialNumber = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };
    const handleFilterUpdate = async (name, value, boolen) => {
        let updatedFilterData;
        updatedFilterData = {
            ...filterdata,
            [name]: value,
            page: 1
        };
        setCurrentPage(1);
        setFilterData(updatedFilterData);
        if (boolen === true) {
            dispatch(getDataSchoolLogos(updatedFilterData))
        }
    };

    const deleteModalOpen = (id) => {
        setDeleteShow(true);
        setDeleteId(id);
    };

    const handleDeleteClose = () => {
        setDeleteShow(false);
    };

    const handleDelete = async () => {
        try {
            let data;
            if (typeof deleteid === "number") {
                data = [deleteid];
            }
            await deleteSchoolLogo({ "school_id": data });
            dispatch(getDataSchoolLogos(requestBody));
            handleDeleteClose();
        } catch (error) { }
    };

    const handleFilter = () => {
        let updatedFilterData = {
            ...filterdata,
            page: 1,
        }
        setCurrentPage(1)
        dispatch(getDataSchoolLogos(updatedFilterData));
    };
    const handleClear = () => {
        let updatedFilterData = {
            ...requestBody,
            page: 1,
        }
        setCurrentPage(1)
        setFilterData(updatedFilterData);
        dispatch(getDataSchoolLogos(updatedFilterData));
    };

    return (
        <>
            <div className="bg-whites mt-4 pt-5">
                <div className="container-fluid inner-section">
                    <SearchBar
                        handleFilterUpdate={handleFilterUpdate}
                        handleFormShow={handleFormShow}
                        editSchoolLogs={editSchoolLogs}
                        handleFilter={handleFilter}
                        handleClear={handleClear}
                    />
                    <Listing
                        logos={logos}
                        totalCount={totalCount}
                        loading={loading}
                        error={error}
                        handleFormShow={handleFormShow}
                        handlePaginate={handlePaginate}
                        calculateSerialNumber={calculateSerialNumber}
                        limit={limit}
                        editSchoolLogs={editSchoolLogs}
                        deleteModalOpen={deleteModalOpen}
                        currentPage={currentPage}
                    />
                </div>
            </div>
            {formshow &&
                <AddUpdateLogos
                    formshow={formshow}
                    handleFormClose={handleFormClose}
                    logoId={logoId}
                    requestBody={requestBody}
                    editSchoolLogs={editSchoolLogs}
                />
            }
            <DeleteModal
                show={deleteshow}
                deleteModalOpen={deleteModalOpen}
                handleDeleteClose={handleDeleteClose}
                handleDelete={handleDelete}
            />
        </>
    )
}

export default SchoolLogoIndex
